import { show, hide } from 'redux-modal'
import { change, getFormValues } from 'redux-form'
import { FILTER_MODAL, FILTER_MODAL_FORM, FILTER_MODAL_FORM_CHECKBOXES } from 'constant'

export const showFilterModal = ({ data } = {}) => show(FILTER_MODAL, { data })

export const hideFilterModal = () => hide(FILTER_MODAL)

const changeCheckboxes = (value = []) => change(FILTER_MODAL_FORM, FILTER_MODAL_FORM_CHECKBOXES, value)

export const handleFiltersClear = () => changeCheckboxes()

export const handleFilterRemove = ({ navigationState }) => (dispatch, getState) => {
  const checkboxes = getFormValues(FILTER_MODAL_FORM)(getState())[FILTER_MODAL_FORM_CHECKBOXES]
  const updatedCheckboxes = checkboxes.filter(checkbox => checkbox !== navigationState)

  dispatch(changeCheckboxes(updatedCheckboxes))
}

export const handleFilterChange = ({ navigationState }, { target: { checked }}) => (dispatch, getState) => {
  const checkboxes = getFormValues(FILTER_MODAL_FORM)(getState())[FILTER_MODAL_FORM_CHECKBOXES]

  const updatedCheckboxes = checked ?
    [...checkboxes, navigationState] :
    checkboxes.filter(checkbox => checkbox !== navigationState)

  dispatch(changeCheckboxes(updatedCheckboxes))
}
